import React from 'react';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {isInternalDHSUser} from 'common/utils';
import {COOKIES} from 'app-ui-componentlibrary/dist/common/constants';
import Cookies from 'universal-cookie';

class InvalidLoginModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
    };
  }

  componentDidMount() {
    if (isInternalDHSUser()) {
      this.setState({
        openModal: true,
      });
    }
  }

  closeModal = () => {
    const cookies = new Cookies();
    cookies.remove(COOKIES.LOGINGOVERROR);

    this.setState({
      openModal: false,
    });
  };

  render() {
    const {openModal} = this.state;

    return (
      <FemaGoModal
        size="small"
        open={openModal}
        buttonText={'Continue to FEMA GO'}
        confirmAction={this.closeModal}
        cancelAction={this.closeModal}
      >
        {
          'It looks like you are trying to login with a FEMA internal user account.  Please go back to FEMA GO login page and use your PIV to sign in.'
        }
      </FemaGoModal>
    );
  }
}

export default InvalidLoginModal;
